import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/app/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import '@miro-site/shared-types';
import React, { useState, useEffect } from 'react';
import cookie from 'js-cookie';
import { getAnalytics as _getAnalytics } from '@miro-site/analytics';
import { jsx as _jsx } from "react/jsx-runtime";
var anonymousIdInterval;
var STATUSES;

(function (STATUSES) {
  STATUSES["loading"] = "loading";
  STATUSES["ready"] = "READY";
  STATUSES["error"] = "ERROR";
})(STATUSES || (STATUSES = {}));

var initialValue = {
  status: STATUSES.loading,
  isLoading: true
};
var SplitIoContext = /*#__PURE__*/React.createContext([initialValue, null]);
export var SplitIoProvider = function SplitIoProvider(props) {
  var children = props.children,
      _props$getAnalytics = props.getAnalytics,
      getAnalytics = _props$getAnalytics === void 0 ? _getAnalytics : _props$getAnalytics,
      _props$authorizationK = props.authorizationKey,
      authorizationKey = _props$authorizationK === void 0 ? process.env.NEXT_PUBLIC_SPLITIO_CLIENT_KEY : _props$authorizationK,
      _props$triesLimit = props.triesLimit,
      triesLimit = _props$triesLimit === void 0 ? 20 : _props$triesLimit,
      _props$nodeEnv = props.nodeEnv,
      nodeEnv = _props$nodeEnv === void 0 ? "production" || 'dev' : _props$nodeEnv;

  var _useState = useState(initialValue),
      splitIOState = _useState[0],
      setSplitIOState = _useState[1];

  var _useState2 = useState(null),
      client = _useState2[0],
      setClient = _useState2[1];

  var environmentName = nodeEnv === 'production' ? 'Prod-Default' : 'Staging-Default';

  function isBot() {
    var userAgent = navigator.userAgent;
    var regexp = /bot|crawl|slurp|spider|mediapartners|go-http-client|apache|axios|ahc/i;
    return !!(userAgent && userAgent.match(regexp));
  }

  useEffect(function () {
    if (isBot()) {
      setSplitIOState({
        status: STATUSES.error,
        error: 'Crawler / bot detected'
      });
    } else {
      setSplitIOState({
        status: STATUSES.loading,
        error: ''
      });
      var tries = 0;
      anonymousIdInterval = window.setInterval(function () {
        if (tries >= triesLimit) {
          setSplitIOState({
            status: STATUSES.error,
            error: "Id cookie wasn't found"
          });
          clearInterval(anonymousIdInterval);
          return;
        }

        var anonymousId = cookie.get('ajs_anonymous_id');

        if (typeof anonymousId === 'string' && anonymousId.length) {
          clearInterval(anonymousIdInterval);
          initSplitIo(anonymousId.replace(/"/g, ''));
        }

        tries++;
      }, 50);
    }

    function initSplitIo(_x) {
      return _initSplitIo.apply(this, arguments);
    }

    function _initSplitIo() {
      _initSplitIo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(anonymousId) {
        var analytics, client;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                analytics = getAnalytics();
                _context2.next = 8;
                break;

              case 4:
                _context2.prev = 4;
                _context2.t0 = _context2["catch"](0);
                setSplitIOState({
                  status: STATUSES.error,
                  error: "Analytics library wasn't initialized"
                });
                return _context2.abrupt("return");

              case 8:
                _context2.next = 10;
                return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  var SplitFactory;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return import('@splitsoftware/splitio');

                        case 2:
                          SplitFactory = _context.sent.SplitFactory;
                          window.split = window.split || SplitFactory({
                            core: {
                              authorizationKey: authorizationKey,
                              key: anonymousId
                            },
                            impressionListener: {
                              logImpression: function logImpression(impression) {
                                var _impression$impressio = impression.impression,
                                    changeNumber = _impression$impressio.changeNumber,
                                    feature = _impression$impressio.feature,
                                    treatment = _impression$impressio.treatment,
                                    label = _impression$impressio.label,
                                    keyName = _impression$impressio.keyName,
                                    time = _impression$impressio.time; // Make sure to connect this in GTM, otherwise events will not land on EventHub

                                analytics.sendCustomEvent('experiment_viewed', {
                                  experiment_id: "".concat(feature, "#").concat(changeNumber),
                                  experiment_name: feature,
                                  variation_id: treatment,
                                  variation_name: treatment,
                                  target: label,
                                  ref_timestamp: time,
                                  ref_key: keyName,
                                  environment_name: environmentName,
                                  traffic_type: 'anonymous_user',
                                  anonymous_id: anonymousId,
                                  attributes: impression.attributes
                                });
                              }
                            }
                          });

                        case 4:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }))();

              case 10:
                // This branch runs only on the client-side
                client = window.split.client();
                _context2.next = 13;
                return client.ready();

              case 13:
                _context2.prev = 13;
                _context2.next = 16;
                return client.ready()["catch"](function (e) {
                  throw e;
                });

              case 16:
                setSplitIOState({
                  status: STATUSES.ready,
                  error: ''
                });
                setClient(client);
                _context2.next = 24;
                break;

              case 20:
                _context2.prev = 20;
                _context2.t1 = _context2["catch"](13);
                setSplitIOState({
                  status: STATUSES.error,
                  error: "Split IO wasn't initialized"
                });
                setClient(client);

              case 24:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 4], [13, 20]]);
      }));
      return _initSplitIo.apply(this, arguments);
    }
  }, []);
  return /*#__PURE__*/_jsx(SplitIoContext.Provider, {
    value: [_objectSpread(_objectSpread({}, splitIOState), {}, {
      isLoading: splitIOState.status == STATUSES.loading
    }), client],
    children: children
  });
};
export var useSplitIo = function useSplitIo() {
  return React.useContext(SplitIoContext);
};
export var useTreatment = function useTreatment(name, attrs) {
  var _useSplitIo = useSplitIo(),
      _useSplitIo2 = _slicedToArray(_useSplitIo, 2),
      isLoading = _useSplitIo2[0].isLoading,
      client = _useSplitIo2[1];

  return [client === null || client === void 0 ? void 0 : client.getTreatment(name, attrs), isLoading];
};